export const DIGITS_ONLY_REGEX = /^[0-9]+$/;

export const DOUBLE_REGEX = /^[+-]?\d*(\.\d*)?$/;
